import {
  Button,
  Card,
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Stack } from '@mui/system';
import Edit02 from '@untitled-ui/icons-react/build/esm/Edit02';
import moment from 'moment';
import Label from '../Label';
import ChevronDownIcon from '@untitled-ui/icons-react/build/esm/ChevronDown';
import ChevronUpIcon from '@untitled-ui/icons-react/build/esm/ChevronUp';
import { DeleteOutlined } from '@mui/icons-material';

type Props = {
  mdsAssessmentData: any;
  handleEditMultipleMds: any;
  handleExpandClick?: any;
  expanded?: any;
  seeButton?: any;
  handleDeleteMultipleMds: any
};

const MultipleMdsAssessmentTable = (props: Props) => {
  const { mdsAssessmentData, handleEditMultipleMds, handleExpandClick, expanded, seeButton, handleDeleteMultipleMds } =
    props;
  return (
    <>
      <Card>
        <Stack
          py={2}
          flexDirection={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          sx={{ background: '#F8F9FA' }}
          my={2}
        >
          <Stack
            flexDirection={'row'}
            gap={5}
            // ml={3}
          >
            <Stack px={3}>
              <Typography
                variant="caption"
                sx={{
                  color: 'rgba(17, 25, 39, 0.38)',
                }}
              >
                Episode Title
              </Typography>
              <Typography variant="subtitle1">{mdsAssessmentData?.episodeTitle} </Typography>
            </Stack>
            <Stack px={3}>
              <Typography
                variant="caption"
                sx={{
                  color: 'rgba(17, 25, 39, 0.38)',
                }}
              >
                Start Date
              </Typography>
              <Typography variant="subtitle1">
                {moment(mdsAssessmentData?.startDate).format('DD MMM, YYYY')}{' '}
              </Typography>
            </Stack>
            {!!mdsAssessmentData?.endDate ? (
              <Stack px={3}>
                <Typography
                  variant="caption"
                  sx={{
                    color: 'rgba(17, 25, 39, 0.38)',
                  }}
                >
                  End Date
                </Typography>
                <Typography variant="subtitle1">
                  {!!mdsAssessmentData?.endDate
                    ? moment(mdsAssessmentData?.endDate).format('DD MMM, YYYY')
                    : '-'}{' '}
                </Typography>
              </Stack>
            ) : null}
          </Stack>
          <Stack mr={3}>
            {mdsAssessmentData?.status === 'CLOSED' ? (
              <Label
                backgroundColor="#F790091F"
                color="#B54708"
                text="CLOSED"
              />
            ) : (
              <Label
                backgroundColor="#15B79E1F"
                color="#107569"
                text="ACTIVE"
              />
            )}
          </Stack>
        </Stack>
        <Stack>
          <Table sx={{ minWidth: 700 }}>
            <TableHead>
              <TableRow>
                <TableCell sortDirection="desc"> Assessment Type</TableCell>
                <TableCell>Assessment DATE</TableCell>
                <TableCell>MDS PT - OT</TableCell>
                <TableCell>MDS SLP</TableCell>
                <TableCell>MDS Nursing</TableCell>
                <TableCell>MDS NTA</TableCell>
                <TableCell>Details</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {/* <TableRow> */}

              {!!mdsAssessmentData?.mdsAssessments?.length ? (
                mdsAssessmentData?.mdsAssessments?.map((mds: any, index: any) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>
                        {mds?.isFinalMds ? mds?.finalMds?.assessmentType : mds?.assessmentType}
                      </TableCell>
                      <TableCell>
                        {(() => {
                          const date = mds?.isFinalMds
                            ? mds?.finalMds?.assessmentDate
                            : mds?.assessmentDate;
                          return date
                            ? moment(
                                new Date(
                                  new Date(date)?.valueOf() +
                                    new Date(date)?.getTimezoneOffset() * 60 * 1000
                                )
                              ).format('DD MMM, YYYY')
                            : '-';
                        })()}
                      </TableCell>
                      <TableCell>
                        {mds?.isFinalMds ? mds?.finalMds?.mdsPtOtGroup : mds?.mdsPtOtGroup}
                      </TableCell>
                      <TableCell>
                        {' '}
                        {mds?.isFinalMds ? mds?.finalMds?.mdsSlpGroup : mds?.mdsSlpGroup}{' '}
                      </TableCell>
                      <TableCell>
                        {' '}
                        {mds?.isFinalMds
                          ? mds?.finalMds?.mdsNursingGroup
                          : mds?.mdsNursingGroup}{' '}
                      </TableCell>
                      <TableCell>
                        {' '}
                        {mds?.isFinalMds ? mds?.finalMds?.mdsNtaGroup : mds?.mdsNtaGroup}
                      </TableCell>
                      <TableCell> {mds?.isFinalMds ? 'Final' : 'Initial'} </TableCell>
                      <TableCell sx={{ gap: .5 }} >
                        <IconButton onClick={() => handleEditMultipleMds(mds)}>
                          <SvgIcon>
                            <Edit02 />
                          </SvgIcon>
                        </IconButton>
                        <IconButton onClick={() => handleDeleteMultipleMds(mds)}>
                          <SvgIcon>
                            <DeleteOutlined />
                          </SvgIcon>
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Box
                      textAlign="center"
                      p={3}
                    >
                      <Typography
                        color={'text.secondary'}
                        variant="subtitle2"
                      >
                        No Records Found
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Stack>
        {seeButton ? (
          <Stack mt={1}>
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              sx={{
                p: 2,
              }}
            >
              <Button
                color="primary"
                size="small"
                onClick={handleExpandClick}
                title={!expanded ? 'See Historical Assessments' : 'Hide Historical Assessments'}
              >
                {expanded ? 'Hide Historical Assessments' : 'See Historical Assessments'}
              </Button>
              <Button
                color="primary"
                onClick={handleExpandClick}
                endIcon={<SvgIcon>{!expanded ? <ChevronDownIcon /> : <ChevronUpIcon />}</SvgIcon>}
              ></Button>
            </Box>
          </Stack>
        ) : null}
      </Card>
    </>
  );
};

export default MultipleMdsAssessmentTable;
